var render, staticRenderFns
import script from "./StitchDialog.vue?vue&type=script&lang=js&"
export * from "./StitchDialog.vue?vue&type=script&lang=js&"
import style0 from "./StitchDialog.vue?vue&type=style&index=0&id=1b0d3749&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0d3749",
  null
  
)

export default component.exports